module.exports = __webpack_public_path__ + "static/media/MissouriHousing_WhiteType-07.6ffde9aa.svg";